/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @flow
 */

import React from 'react';
import Body from '../../components/Body';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import classes from './Desktop.module.css';
import CubbyMenu from '../../../Fireboard/components/CubbyMenu';
import CubbyLayoutPopup from '../../../StoreCubby/components/CubbyLayoutPopup';
import FireboardSmsComponent from '../../../Fireboard/components/SmsComponent';
import MemberDetails from '../../../Fireboard/components/MemberDetails';
import CommonUtil from '../../../Fireboard/common';
import CheckActions from '../../../Fireboard/components/CheckActions';
import TextToPay from '../../../Fireboard/components/TextToPay';
import CheckInRequest from '../../../Fireboard/components/CheckInRequest';
import RePostPayment from '../../../Fireboard/components/RePostPayment';
import { RedeemVoucher } from '../../../Fireboard/components/RedeemVoucher';
import ViewGuestLocation from '../../../Fireboard/components/ViewGuestLocation';
import UpdateGuestPhoneNumber from '../../../Fireboard/components/UpdateGuestPhoneNumber';
import CaptureSeatName from '../../../Fireboard/components/CaptureSeatName';
import ManagerLogin from '../../../Fireboard/components/ManagerLogin';

export default function Desktop(props) {
  const {
    popup,
    showPopup,
    closePopup,
    iso2,
    currency,
    isCustomSmsType,
    storeInfo,
    customSmsList,
    onChangeSmsType,
    onHandleSend,
    selectedCheck,
    twoDimensionSlot,
    onMoveSlotOrder,
    cubbyLayoutPopupType,
    onCubbyMenuPress,
    onPressManageCubby,
    isDevEnvironment,
    fromFooter,
    updateOrderStatus,
    onQRGenerate,
    markItemAsPaid,
    onHandleTextToPay,
    textToCheckIn,
    notifyOrderPrepared,
    notifyOrderReady,
    notifyOrderStatus,
    onResyncCheck,
    joinCheck,
    invokeTextToPay,
    invokeCheckIn,
    openPaymentHistory,
    rePostPayment,
    onPressRedeemVoucher,
    onRedeemVoucher,
    onRequestRefreshGuestGPS,
    onOrderDelivered,
    onUpdateGuestInformation,
    markAsSeeCounter,
    onUpdateSeatName,
    enableAgeRestrictedOrderingForCheck,
    onUpdateAgeRestrictedItemsForCheck,
    enableAgeVerification,
    markAsAgeVerified,
    onLogin,
  } = props;

  const selectedCheckDetails = {
    checkNumber: selectedCheck.checkNumber,
    phoneNumber: selectedCheck.phoneNumber,
    pickupDate: selectedCheck.pickupDate,
    taxAmount: selectedCheck.taxAmount,
    guestName: selectedCheck.guestName,
    subTotalAmount: selectedCheck.subTotalAmount,
  };

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      case 'cubbyMenu':
        return (
          <CubbyMenu
            onClose={closePopup}
            onCubbyMenuPress={onCubbyMenuPress}
            slotName={selectedCheck?.slotName}
          />
        );
      case 'cubbyLayout':
        return (
          <CubbyLayoutPopup
            closePopup={closePopup}
            twoDimensionSlot={twoDimensionSlot}
            buttonText={cubbyLayoutPopupType}
            onMoveSlotOrder={onMoveSlotOrder}
          />
        );
      case 'sms':
        return (
          <FireboardSmsComponent
            selectedItem={selectedCheck}
            onHandleSend={onHandleSend}
            storeInfo={storeInfo}
            onClose={closePopup}
            iso2={iso2}
            currency={currency}
            isCustomSmsType={isCustomSmsType}
            customSmsList={customSmsList}
            onChangeSmsType={onChangeSmsType}
          />
        );
      case "check-actions":
        return (
          <CheckActions
            hideCubbyManager={false}
            dismissPopup={closePopup}
            currency={currency}
            managerMode={false}
            updateOrderStatus={updateOrderStatus}
            markItemAPaid={markItemAsPaid}
            onQRGenerate={onQRGenerate}
            // selectCheck
            onHandleSms={() => showPopup('sms')}
            onHandleTextToPay={onHandleTextToPay}
            textToCheckIn={textToCheckIn}
            selectedItem={selectedCheck}
            onResyncCheck={onResyncCheck}
            // onPreAuth
            joinCheck={joinCheck}
            openPaymentHistory={openPaymentHistory}
            notifyOrderReady={notifyOrderReady}
            notifyOrderPrepared={notifyOrderPrepared}
            notifyOrderStatus={notifyOrderStatus}
            onPressRedeemVoucher={onPressRedeemVoucher}
            enableGpsLocation={storeInfo?.enableGpsLocation}
            latitude={storeInfo?.latitude}
            longitude={storeInfo?.longitude}
            viewGuestLocationOnMap={() => showPopup('viewOnMap')}
            onPressManageCubby={onPressManageCubby}
            onOpenUpdateGuestInformationModal={() => showPopup('updateGuestInformation')}
            markAsSeeCounter={markAsSeeCounter}
            enableAgeRestrictedOrderingForCheck={enableAgeRestrictedOrderingForCheck}
            onUpdateAgeRestrictedItemsForCheck={onUpdateAgeRestrictedItemsForCheck}
            enableAgeVerification={enableAgeVerification}
            markAsAgeVerified={markAsAgeVerified}
          />
        );
      case "generate-qr": {
        return CommonUtil.renderQR(
          popup.meta || null,
          isDevEnvironment,
          closePopup,
          null,
          selectedCheck,
          null,
          null,
          currency,
        );
      }
      case "generate-qr-join-check": {
        return CommonUtil.renderQRToJoinCheck(
          popup.meta || null,
          popup.sensorData || null,
          isDevEnvironment,
          closePopup,
        );
      }
      case "textToPay": {
        return (
          <TextToPay
            invokeTextToPay={invokeTextToPay}
            selectedItem={{
              ...selectedCheck,
              selectedCheckDetails: { ...selectedCheckDetails },
            }}
            fromFooter={fromFooter}
            onClose={closePopup}
            currency={currency}
            iso2={iso2}
          />
        );
      }
      case "checkIn": {
        return (
          <CheckInRequest
            invokeCheckIn={invokeCheckIn}
            selectedItem={{
              ...selectedCheck,
              selectedCheckDetails: { ...selectedCheckDetails },
            }}
            fromFooter={fromFooter}
            onClose={closePopup}
            currency={currency}
            iso2={iso2}
          />
        );
      }
      case 'repostpayment': {
        return (
          <RePostPayment
            selectedItem={selectedCheck}
            onClose={closePopup}
            currency={currency}
            iso2={iso2}
            rePostPayment={rePostPayment}
          />
        );
      }
      case 'redeemCheckVoucher':
        return (
          <RedeemVoucher
            iso2={iso2}
            currency={currency}
            selectedCheck={selectedCheck}
            onClosePopup={closePopup}
            onRedeemVoucher={onRedeemVoucher}
          />
        );
      case 'viewOnMap':
        return (
          <ViewGuestLocation
            onClose={closePopup}
            check={selectedCheck}
            storeInfo={storeInfo}
            currency={currency}
            onRequestRefresh={onRequestRefreshGuestGPS}
            onOrderDelivered={onOrderDelivered}
          />
        );
      case "member-details": {
        return (
          <MemberDetails
            activeItem={popup.metaData}
            onClose={closePopup}
            iso2={iso2}
          />
        );
      }
      case 'updateGuestInformation': {
        return (
          <UpdateGuestPhoneNumber
            onClose={closePopup}
            iso2={iso2}
            selectedCheck={selectedCheck}
            onUpdateGuestInformation={onUpdateGuestInformation}
          />
        );
      }
      case 'captureSeatName': {
        return (
          <CaptureSeatName
            onClose={closePopup}
            onUpdateSeatName={onUpdateSeatName}
          />
        );
      }
      case 'login': {
        return (
          <ManagerLogin
            onLoginPress={onLogin}
            closePopup={closePopup}
            indentifier={popup?.metaData?.indentifier || null}
          />
        );
      }
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  const getPopupStyle = () => {
    let popupStyle = { width: '31.25vw' };
    if (popup && popup.type === 'spinner') {
      popupStyle = { width: '50%' };
    } else if (popup && popup.type === 'cubbyMenu') {
      popupStyle = { width: '30%' };
    } else if (popup && popup.type === 'cubbyLayout') {
      popupStyle = { width: '90%', height: '95%' };
    } else if (popup && popup.type === 'sms') {
      popupStyle = { height: '90vh', width: '70vw' };
    } else if (popup && popup.type === "check-actions") {
      popupStyle = { minWidth: '23vw', width: null, maxWidth: '88vw' }
    } else if (popup && (popup.type === "textToPay" || popup.type === "checkIn")) {
      popupStyle = { width: "34vw" };
    } else if (popup && popup.type === 'repostpayment') {
      popupStyle = { height: '80%', width: '50%' };
    } else if (popup && (popup.type === "generate-qr" || popup.type === "generate-qr-join-check")) {
      popupStyle = { width: "98vw", height: "90vh" };
    } else if (popup && (popup.type === 'redeemCheckVoucher')) {
      popupStyle = { width: '60%' };
    } else if (popup && popup.type === 'viewOnMap') {
      popupStyle = { width: '70%' };
    } else if (popup && popup.type === "member-details") {
      popupStyle = { width: "34vw" };
    } else if (popup && popup.type === 'updateGuestInformation') {
      popupStyle = { width: '30%' };
    } else if (popup && popup.type === 'captureSeatName') {
      popupStyle = { width: '30%' };
    } else if (popup && popup.type === 'login') {
      popupStyle = { width: '100vw', height: '100vh' };
    }
    return popupStyle;
  };

  return (
    <div className={classes.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        {getPopupContent()}
      </Popup>
      <Body {...props} />
    </div>
  );
}
